<template>
	<div class="treat-page">
		<time-num></time-num>
		<div class="content">
			<div @click="handleTab(index)" v-for="(item, index) in catalogueList" :key="index" class="item"
				:class="overIndex === item.id ? 'item-active' : ''">
				<img :src="overIndex === index ? item.icon_Select : item.icon" alt />
				<div>{{ item.title }}</div>
			</div>
		</div>
		<div class="page-mouthModal" v-if="visible">
			<div class="content">
				<div class="title">提示！</div>
				<div class="text">
					<p>{{ visibleName }}</p>
				</div>
				<div class="footer">
					<button @click="handleOk">确定</button>
				</div>
			</div>
		</div>
		<mi-xin></mi-xin>
	</div>
</template>

<script>
	import {
		mapMutations,
		mapState
	} from "vuex";
	import MiXin from "../mixins/index";
	import TimeNum from "../mixins/timeNum";
	import {
		submitExamCommitSingerAnswer
	} from "../../api/system/exam";
	export default {
		components: {
			MiXin,
			TimeNum,
		},
		data() {
			return {
				visible: false,
				visibleName: "",
				catalogueList: [{
						icon: require("./../../assets/treat/intellecto.png"),
						icon_Select: require("./../../assets/treat/intellectt.png"),
						title: "Step1：宠物主诉",
						id: 0,
					},
					{
						icon: require("./../../assets/treat/intellectobjo.png"),
						icon_Select: require("./../../assets/treat/intellectobjt.png"),
						title: "Step2：视诊",
						id: 1,
					},
					{
						icon: require("./../../assets/treat/askZheo.png"),
						icon_Select: require("./../../assets/treat/askZhet.png"),
						title: "Step3：鉴别诊断",
						path: "/treat/grade",
						id: 2,
					},
					{
						icon: require("./../../assets/treat/inspectiono.png"),
						icon_Select: require("./../../assets/treat/inspectiont.png"),
						title: "Step4：临床检查",
						id: 3,
					},
					{
						icon: require("./../../assets/treat/diagnoseo.png"),
						icon_Select: require("./../../assets/treat/diagnoseot.png"),
						title: "Step5：最终诊断",
						id: 4,
					},
					{
						icon: require("./../../assets/treat/drugo.png"),
						icon_Select: require("./../../assets/treat/drugt.png"),
						title: "Step6：确认疗法",
						id: 5,
					},
				],
				tabIndex: "",
			};
		},
		computed: {
			...mapState("visualExamination", [
				"selectPosition",
				"contentObj",
				"overIndex",
				"treatmentList",
				//步骤二
				"detail",
				//步骤三
				"detailsz2",
				//步骤四
				"detail3",
				"detailstepPre3",
				//步骤五
				"detail4",
				//步骤六
				"detail5",
				"treatmentEcho",
			]),
			...mapState("microscope", ["examDetailId"]),
		},
		created() {},
		mounted() {},
		methods: {
			...mapMutations("visualExamination", ["VISUAL_EXAMINATION"]),
			//关闭弹框
			handleOk() {
				this.visible = false;
			},

			//切换
			handleTab(i) {
				// this.tabIndex = i
				let newArr = [
					...this.detail,
					...this.detailsz2,
					...this.detail3,
					...this.detailstepPre3,
					...this.detail4,
					...this.detail5,
				];
				
				const parmes = {
					paperId: this.treatmentList.id,
					details: newArr,
				};
				switch (i) {
					case 0:
					
						submitExamCommitSingerAnswer({
							backendAnswers: JSON.stringify(parmes),
							paperId: this.treatmentList.id,
							questionId: '-206',
							answers: JSON.stringify({
								detail: this.detail,
								detailsz2: this.detailsz2,
								detail3: this.detail3,
								detailstepPre3: this.detailstepPre3,
								detail4: this.detail4,
								detail5: this.detail5,
								treatmentEcho: this.treatmentEcho
							}),
							extractDetailId: this.examDetailId,
						}).then((response) => {
							// this.$router.replace({
							// 	path: "/treat/complaint"
							// });
							this.enterNextPage()
						});

						break;
					case 1:
						if (this.overIndex <= 1) {
							if (this.contentObj.stepTwo) {
								submitExamCommitSingerAnswer({
									backendAnswers: JSON.stringify(parmes),
									paperId: this.treatmentList.id,
									questionId: '-2010',
									answers: JSON.stringify({
										detail: this.detail,
										detailsz2: this.detailsz2,
										detail3: this.detail3,
										detailstepPre3: this.detailstepPre3,
										detail4: this.detail4,
										detail5: this.detail5,
										treatmentEcho: this.treatmentEcho
									}),
									extractDetailId: this.examDetailId,
								}).then((response) => {
									this.$router.replace({
										path: "/treat/point"
									});
								});

							} else {
								this.visibleName = "请按照顺序答题";
								this.visible = true;
							}
						} else {
							this.visibleName = "已作答完成请勿修改";
							this.visible = true;
						}
						break;
					case 2:
						if (this.overIndex <= 2) {
							if (this.contentObj.stepThree) {
								submitExamCommitSingerAnswer({
									backendAnswers: JSON.stringify(parmes),
									paperId: this.treatmentList.id,
									questionId: '-2014',
									answers: JSON.stringify({
										detail: this.detail,
										detailsz2: this.detailsz2,
										detail3: this.detail3,
										detailstepPre3: this.detailstepPre3,
										detail4: this.detail4,
										detail5: this.detail5,
										treatmentEcho: this.treatmentEcho
									}),
									extractDetailId: this.examDetailId,
								}).then((response) => {
									this.$router.replace({
										path: "/treat/distinguish"
									});
								});

							} else {
								this.visibleName = "请按照顺序答题";
								this.visible = true;
							}
						} else {
							this.visibleName = "已作答完成请勿修改";
							this.visible = true;
						}
						break;
					case 3:
						if (this.overIndex < 4) {
							if (this.contentObj.stepFour) {
								submitExamCommitSingerAnswer({
									backendAnswers: JSON.stringify(parmes),
									paperId: this.treatmentList.id,
									questionId: '-2015',
									answers: JSON.stringify({
										detail: this.detail,
										detailsz2: this.detailsz2,
										detail3: this.detail3,
										detailstepPre3: this.detailstepPre3,
										detail4: this.detail4,
										detail5: this.detail5,
										treatmentEcho: this.treatmentEcho
									}),
									extractDetailId: this.examDetailId,
								}).then((response) => {
									this.$router.replace({
										path: "/treat/clinical"
									});
								});

							} else {
								this.visibleName = "请按照顺序答题";
								this.visible = true;
							}
						} else {
							this.visibleName = "已作答完成请勿修改";
							this.visible = true;
						}
						break;
					case 4:
						if (this.overIndex < 5) {
							if (this.contentObj.stepFive) {
								submitExamCommitSingerAnswer({
									backendAnswers: JSON.stringify(parmes),
									paperId: this.treatmentList.id,
									questionId: '-2016',
									answers: JSON.stringify({
										detail: this.detail,
										detailsz2: this.detailsz2,
										detail3: this.detail3,
										detailstepPre3: this.detailstepPre3,
										detail4: this.detail4,
										detail5: this.detail5,
										treatmentEcho: this.treatmentEcho
									}),
									extractDetailId: this.examDetailId,
								}).then((response) => {
									this.$router.replace({
										path: "/treat/final"
									});
								});

							} else {
								this.visibleName = "请按照顺序答题";
								this.visible = true;
							}
						} else {
							this.visibleName = "已作答完成请勿修改";
							this.visible = true;
						}
						break;
					case 5:
						if (this.overIndex < 6) {
							if (this.contentObj.stepSix) {
								submitExamCommitSingerAnswer({
									backendAnswers: JSON.stringify(parmes),
									paperId: this.treatmentList.id,
									questionId: '-2017',
									answers: JSON.stringify({
										detail: this.detail,
										detailsz2: this.detailsz2,
										detail3: this.detail3,
										detailstepPre3: this.detailstepPre3,
										detail4: this.detail4,
										detail5: this.detail5,
										treatmentEcho: this.treatmentEcho
									}),
									extractDetailId: this.examDetailId,
								}).then((response) => {
									this.$router.replace({
										path: "/treat/affirm"
									});
								});

							} else {
								this.visibleName = "请按照顺序答题";
								this.visible = true;
							}
						} else if (this.overIndex === 6) {
							submitExamCommitSingerAnswer({
								backendAnswers: JSON.stringify(parmes),
								paperId: this.treatmentList.id,
								questionId: '-2018',
								answers: JSON.stringify({
									detail: this.detail,
									detailsz2: this.detailsz2,
									detail3: this.detail3,
									detailstepPre3: this.detailstepPre3,
									detail4: this.detail4,
									detail5: this.detail5,
									treatmentEcho: this.treatmentEcho
								}),
								extractDetailId: this.examDetailId,
							}).then((response) => {
								this.$router.replace({
									path: "/treat/examineResult"
								});
							});

						}
						break;
					default:
						break;
				}
			},
			//去掉宠物视频页面，直接进行下一步
			enterNextPage(){
				
				this.VISUAL_EXAMINATION({
					key: "treatModleTime",
					value: true
				});
				if (this.treatmentList.scoreSheet) {
					let newArr = [
						...this.detail,
						...this.detailsz2,
						...this.detail3,
						...this.detailstepPre3,
						...this.detail4,
						...this.detail5,
					];
					const parmes = {
						paperId: this.treatmentList.id,
						details: newArr,
					};
					submitExamCommitSingerAnswer({
						backendAnswers: JSON.stringify(parmes),
						paperId: this.treatmentList.id,
						questionId: '-207',
						answers: JSON.stringify({
							detail: this.detail,
							detailsz2: this.detailsz2,
							detail3: this.detail3,
							detailstepPre3: this.detailstepPre3,
							detail4: this.detail4,
							detail5: this.detail5,
							treatmentEcho: this.treatmentEcho
						}),
						extractDetailId: this.examDetailId,
					}).then((response) => {
						this.$router.replace("/treat/pruritus");
					});
								
				} else {
					let newArr = [
						...this.detail,
						...this.detailsz2,
						...this.detail3,
						...this.detailstepPre3,
						...this.detail4,
						...this.detail5,
					];
					const parmes = {
						paperId: this.treatmentList.id,
						details: newArr,
					};
					submitExamCommitSingerAnswer({
						backendAnswers: JSON.stringify(parmes),
						paperId: this.treatmentList.id,
						questionId: '-208',
						answers: JSON.stringify({
							detail: this.detail,
							detailsz2: this.detailsz2,
							detail3: this.detail3,
							detailstepPre3: this.detailstepPre3,
							detail4: this.detail4,
							detail5: this.detail5,
							treatmentEcho: this.treatmentEcho
						}),
						extractDetailId: this.examDetailId,
					}).then((response) => {
						this.$router.replace({
							path: "/treat/medicalrecord",
							query: {
								num: 1.1
							},
						});
					});
								
				}
			},
		},
	};
</script>

<style lang="less" scoped>
	.time-num {
		padding: 10px 0;
	}

	.treat-page {
		width: 100%;
		min-height: 100vh;
		background-image: url("./../../assets/home/xwjBg.png");
		background-repeat: no-repeat;
		background-size: 100% 100%;
		padding: 0 53px 91px 53px;
		box-sizing: border-box;

		.content {
			padding: 0 53px;
			width: 100%;
			height: 1266px;
			background: rgba(255, 255, 255, 0.3);
			box-shadow: 0px 30px 70px 0px rgba(13, 96, 103, 0.65);
			border: 2px solid #ffffff;
			border-radius: 60px;
			padding: 111px 83px 224px 73px;
			box-sizing: border-box;

			.item {
				display: flex;
				align-items: center;
				width: 497px;
				height: 101px;
				background: #e5e5e5;
				border: 1px solid #ffffff;
				box-shadow: 0px 0px 10px 0px rgba(36, 36, 36, 0.29);
				border-radius: 50px;
				font-size: 35px;
				font-weight: 500;
				color: #333333;

				img {
					width: 42px;
					margin-left: 55px;
					margin-right: 34px;
				}
			}

			.item:not(:first-child) {
				margin-top: 65px;
			}

			.item-active {
				background: linear-gradient(132.74deg,
						rgba(0, 187, 177, 1) 0%,
						rgba(0, 86, 140, 1) 74.31%,
						rgba(171, 59, 127, 1) 100%);
				color: #ffffff;
			}
		}

		.page-mouthModal {
			width: 100%;
			min-height: 100vh;
			position: absolute;
			left: 0;
			top: 0;
			background: rgba(#fff, 0.8);
			display: flex;
			align-items: center;
			z-index: 1;
			padding: 0px 40px;
			box-sizing: border-box;

			.content {
				width: 100%;
				height: 642px;
				z-index: 999;
				background: #ffffff;
				background: rgba(255, 255, 255, 0.9);
				border: 2px solid #ffffff;
				border-radius: 60px;
				display: flex;
				flex-direction: column;
				align-items: center;
				justify-content: center;
				padding-top: 90px;
				padding-bottom: 77px;
			}

			.title {
				font-size: 65px;
				font-family: HarmonyOS Sans SC;
				font-weight: bold;
				color: #ab3b91;
			}

			.text {
				font-size: 35px;
				font-family: HarmonyOS Sans SC;
				font-weight: bold;
				color: #333333;
				line-height: 60px;
				margin-top: 80px;
				text-align: center;
			}

			.footer {
				margin-top: 110px;

				button {
					width: 262px;
					height: 79px;
					background: linear-gradient(132.74deg,
							rgba(0, 187, 177, 1) 0%,
							rgba(0, 86, 140, 1) 74.31%,
							rgba(171, 59, 127, 1) 100%);
					border: 1px solid #ffffff;
					box-shadow: 0px 0px 10px 0px rgba(36, 36, 36, 0.29);
					text-align: center;
					font-size: 35px;
					font-family: HarmonyOS Sans SC;
					font-weight: 500;
					color: #ffffff;
					line-height: 60px;
					letter-spacing: 2px;
					border-radius: 40px;
				}

				button:nth-child(2) {
					margin-left: 42px;
				}
			}
		}
	}
</style>